/**
 * Sets cookie
 * @ignore
 * @param {string} cname - Cookie name
 * @param {string} cvalue - Cookie value
 * @return {void}
 */
export default function setCookie(cname, cvalue, expiry = 365) {
    const d = new Date();
    d.setTime(d.getTime() + (expiry * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
